import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { Editor } from "components/shared/Editor";
import { addService, addWork } from "store/actions";
import { useNavigate } from "react-router-dom";
import ImageUploadEn from "./ImageUploadEn";
import SaveChangesButton from "components/shared/SaveChangesButton";
import DragDropUploader from "../../components/shared/DaragedUploader/DragDropUploader";
import { toast } from "react-toastify";

const AddWork = () => {
  const [selectedMainImage, setSelectedMainImage] = useState();
  const [selectedImages, setSelectedImages] = useState([]); // To store multiple images
  const [description, setDescription] = useState({ ar: "", en: "" });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  // Function to handle adding a new image upload field
  // const handleAddImageField = () => {
  //   setSelectedImages([...selectedImages, { id: Date.now(), image: null }]); // Add new field with unique ID
  // };

  // // Function to handle individual image upload change
  // const handleImageChange = (id, image) => {
  //   setSelectedImages((prev) =>
  //     prev.map((img) => (img.id === id ? { ...img, image } : img))
  //   );
  // };

  const onSubmit = async (data) => {


    try {
      if (selectedMainImage) data.image = selectedMainImage.path;
      
      data.description = description;
      data.images = selectedImages.map((img) => img.path);

      await dispatch(
        addWork({
          page: "ourWorks",
          data: { section: { title: data?.heading?.en, data } },
          navigate,
          toast
        })
      );
    } catch (error) {
      console.error("Error submitting work:", error);
    }
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="addWork" />
            </h4>
          </div>
          <div className="card-body form-group settings-tabs">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  {/* Main Image Upload */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="image" />
                      </h5>
                      <ImageUploadEn
                        selectedImageEn={selectedMainImage}
                        setSelectedImageEn={setSelectedMainImage}
                        accept="image/*"
                      />
                    </div>
                  </Col>
                  <Row>

                    <Col lg={6}>
                      <h5>
                        <FormattedMessage id="multipleImages" />
                      </h5>
                    </Col>
                    <Col lg={12} className="d-flex justify-content-center w-100">
                      <DragDropUploader
                        selectedImages={selectedImages}
                        setSelectedImages={setSelectedImages}
                      />
                    </Col>

                  </Row>
                  {/* Multiple Image Uploads */}
                  {/* <Col lg={12}>
                    <div className="form-group">
                      <h5><FormattedMessage id="additionalImages" /></h5>
                      <Row>

                        {selectedImages.map((imgField, index) => (
                          <Col key={index + 8888} md={4} xs={12} className="text-left">
                            <div key={imgField.id} className="form-group required">
                              <ImageUploadEn
                                selectedImageEn={imgField.image}
                                setSelectedImageEn={(image) =>
                                  handleImageChange(imgField.id, image)
                                }
                                accept="image/svg+xml, image/jpeg, image/png"
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>

                    
                      <Row>
                        <Col lg={4} xs={12} className="text-left">
                          <button
                            type="button"
                            className="btn btn-green add_new_section__ mb-3"
                            onClick={handleAddImageField}
                          >
                            <FormattedMessage id="addImage" />
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </Col> */}

                  {/* Title Inputs */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" /> (
                        <FormattedMessage id="arabic-language" />)
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("heading.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.heading?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" /> (
                        <FormattedMessage id="english-language" />)
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("heading.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.heading?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>



                  {/* Subtitle Inputs */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="subTitle" /> (
                        <FormattedMessage id="arabic-language" />)
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("subHeading.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.subHeading?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="subTitle" /> (
                        <FormattedMessage id="english-language" />)
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("subHeading.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.subHeading?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="location" /> (
                        <FormattedMessage id="arabic-language" />)
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("location.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.location?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="location" /> (
                        <FormattedMessage id="english-language" />)
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("location.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.location?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="clientName" /> (
                        <FormattedMessage id="arabic-language" />)
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("clientName.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.clientName?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="clientName" /> (
                        <FormattedMessage id="english-language" />)
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("clientName.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.clientName?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="startDate" />

                      </h5>
                      <input
                        type="date"
                        className="form-control"
                        {...register("startDate", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.startDate?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="endDate" />
                      </h5>
                      <input
                        type="date"
                        className="form-control"
                        {...register("endDate", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.endDate?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  {/* Description Editors */}
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (
                        <FormattedMessage id="arabic-language" />)
                      </h5>
                      <Controller
                        control={control}
                        name="description.ar"
                        render={() => (
                          <Editor
                            initialValue=""
                            onChange={(e, editor) => {
                              const data = editor.getContent();
                              setDescription((prev) => ({
                                ...prev,
                                ar: data,
                              }));
                            }}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.description?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (
                        <FormattedMessage id="english-language" />)
                      </h5>
                      <Controller
                        control={control}
                        name="description.en"
                        render={() => (
                          <Editor
                            initialValue=""
                            onChange={(e, editor) => {
                              const data = editor.getContent();
                              setDescription((prev) => ({
                                ...prev,
                                en: data,
                              }));
                            }}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.description?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>

              {/* Submit Button */}
           
                <SaveChangesButton addNew={true} />
          
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddWork;